import { useEffect, useState } from 'react'

function useMediaQuery(query, defaultValue = false) {
  const [mediaQueryResult, setMediaQueryResult] = useState(defaultValue)

  useEffect(() => {
    setMediaQueryResult(window.matchMedia(query).matches)

    const handleResize = (e) => {
      setMediaQueryResult(e.matches)
    }

    const mediaQuery = window.matchMedia(query)

    mediaQuery.addEventListener('change', handleResize)

    // Clean up the event listener when the component unmounts
    return () => {
      mediaQuery.removeEventListener('change', handleResize)
    }
  }, [query])

  return {
    mediaQueryResult,
  }
}

export default useMediaQuery
